<template>
<div>
 <div justify="center" v-if="Loaded">
<v-card class=" mt-4 mx-auto" max-width="1000" min-width="300">

  <v-toolbar class="pencil"   color="orange ligthen-1" dark>
          <v-toolbar-title>{{Hide?"Överlämning "+getActivity.name:"Tack"}}!
           
           </v-toolbar-title>

         
          <v-spacer></v-spacer>

        </v-toolbar>

  <v-expand-transition>
        <div v-if="Hide" class="pa-5">
            <p v-if="school!=null">
   Vi på {{school.name}} kontaktar er via vår elevhälsoplattform EHTkollen för att mottaga överlämningen för {{getActivity.name}}. Tack iförväg för gott samarbete.
 </p>
<Overleave :getActivity="getActivity" v-on:childToParent="onChildClick" ToFrom="To" />

    
        </div>
  </v-expand-transition>
</v-card>  
  </div>
  <div v-else class="loader text-xs-center">
    <v-progress-circular
      indeterminate
      color="primary"
    ></v-progress-circular>
  </div>
</div>

</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import Overleave from "../../components/StudentChange/Overleave.vue";
export default {
  components: {
    Overleave
  },
 props: {
    nurseId: String
  },
  data: () => ({
      loaded:false,
      send:false,
      Hide: true,      
      activePicker: null,

  }),
  computed: {
   
    
    ...mapGetters('schools', ['school']),
    ...mapGetters("ehtmembers", ["getActivity"]),
    Loaded(){
      if (this.getActivity!= null) {
        this.loaded=true
        if (this.loaded==false) {
        this.initschool(this.getActivity.schoolId)
        }
        return true;
      }
      return false;
    },
  },
  watch: {
      menu (val) {
        val && setTimeout(() => (this.activePicker = 'YEAR'))
      },
    },
    methods: {

  onChildClick (value) {
      this.Hide = value
    },
    ...mapActions('schools', ['initschool']),
      ...mapActions('ehtmembers', ['GetStartEnd']),

    ...mapActions(['showSuccessSnackbar']),
    ...mapActions("ehtmembers", ["updatePlan"]),

  },
  created () {
   
this.GetStartEnd(this.nurseId);
   
  },
}
</script>
<style>
.loader{
  margin-top: 20vh;
}



</style>
